export default [
  "House Lannister of Casterly Rock",
  "House Stark of Winterfell",
  "House Targaryen of King's Landing",
  "House Baratheon of King's Landing",
  "House Baratheon of Storm's End",
  "House Tyrell of Highgarden",
  "House Baelish of Harrenhal",
  "House Bolton of the Dreadfort",
  "House Greyjoy of Pyke",
  "House Nymeros Martell of Sunspear",
  "House Tully of Riverrun",
  "House Frey of the Crossing"
];
